import fetch from './fetch.js'
//
  ;(function () {
  let $containers = document.querySelectorAll('[data-inject]')
  if (!$containers.length) return
  for (let i = 0; i < $containers.length; i++) {
    let $container = $containers[i]
    let url = $container.getAttribute('data-inject')
    fetch(url)
      .then(res => res.text())
      .then(html => {
        defer(() => {
          $container.innerHTML = html

          let callback = $container.getAttribute('data-callback')
          if (callback) {
            window.LBA[callback](
              $container.hasAttribute('data-root')
                ? $container.querySelector($container.getAttribute('data-root'))
                : $container.firstElementChild
            )
          }
        })
      })
  }
})()

function defer (cb) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(cb)
  } else {
    window.setTimeout(cb, 0)
  }
}



// WEBPACK FOOTER //
// ./src/js/_inject.js